const helpTextIcon = (key, shortText, className = '') => {
  return <i className={`bi bi-info-circle ml-1 ${!shortText ? 'has-no-short-text' : ''} ${className}`} id={`help-${key}`}></i>
};

const helpTextIconString = (key, shortText) => {
  return `<i class='bi bi-info-circle ml-1 ${!shortText ? "has-no-short-text" : ""}' id='help-${key}'></i>`;
};

const renderHelpIcon = (helpsObj, key, className = '') => {
  const item = helpsObj?.[key];
  return item ? helpTextIcon(key, item.short_text, className) : null;
};

export { helpTextIcon, helpTextIconString, renderHelpIcon };
